var _path, _path2, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgProfileMessageIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.7769 13.4645C11.1079 13.4645 10.4409 13.2435 9.88286 12.8015L5.39786 9.1855C5.07486 8.9255 5.02486 8.4525 5.28386 8.1305C5.54486 7.8095 6.01686 7.7585 6.33886 8.0175L10.8199 11.6295C11.3829 12.0755 12.1759 12.0755 12.7429 11.6255L17.1789 8.0195C17.5009 7.7565 17.9729 7.8065 18.2349 8.1285C18.4959 8.4495 18.4469 8.9215 18.1259 9.1835L13.6819 12.7955C13.1199 13.2415 12.4479 13.4645 11.7769 13.4645Z",
    fill: "#505050"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_144_3637",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 1,
    y: 2,
    width: 22,
    height: 20
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1 2H22.4999V21.5H1V2Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_144_3637)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.83888 20H16.6589C16.6609 19.998 16.6689 20 16.6749 20C17.8159 20 18.8279 19.592 19.6039 18.817C20.5049 17.92 20.9999 16.631 20.9999 15.188V8.32C20.9999 5.527 19.1739 3.5 16.6589 3.5H6.84088C4.32588 3.5 2.49988 5.527 2.49988 8.32V15.188C2.49988 16.631 2.99588 17.92 3.89588 18.817C4.67188 19.592 5.68488 20 6.82488 20H6.83888ZM6.82188 21.5C5.27888 21.5 3.90088 20.94 2.83688 19.88C1.65188 18.698 0.999878 17.032 0.999878 15.188V8.32C0.999878 4.717 3.51088 2 6.84088 2H16.6589C19.9889 2 22.4999 4.717 22.4999 8.32V15.188C22.4999 17.032 21.8479 18.698 20.6629 19.88C19.5999 20.939 18.2209 21.5 16.6749 21.5H16.6589H6.84088H6.82188Z",
    fill: "#505050"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileMessageIcon);
export default __webpack_public_path__ + "static/media/profileMessageIcon.4ba63179a1b2c8c6c974af06a50e1460.svg";
export { ForwardRef as ReactComponent };